module.exports = __webpack_public_path__ + "static/media/dots.e0b237e8.png";